<template>
  <v-container fluid class="pa-1">
    <!-- Título de la página -->
    <div class="mb-2">
      <h1 class="display-1 font-weight-bold">Panel de Solicitudes</h1>
      <h2 class="subtitle-1 text--secondary">
        Visualiza métricas clave y tendencias de solicitudes
      </h2>
    </div>

    <!-- Filtros -->
    <v-card class="pa-4 mb-6 border" shaped>
      <v-row dense align="center" class="flex-wrap">
        <v-col cols="12" sm="4" md="3">
          <v-menu
            v-model="startDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filters.startDate"
                label="Fecha inicio"
                prepend-icon="mdi-calendar"
                readonly
                dense
                outlined
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filters.startDate"
              @input="
                () => {
                  startDateMenu = false;
                  aplicarFiltros();
                }
              "
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="4" md="3">
          <v-menu
            v-model="endDateMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="filters.endDate"
                label="Fecha fin"
                prepend-icon="mdi-calendar"
                readonly
                dense
                outlined
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filters.endDate"
              @input="
                () => {
                  endDateMenu = false;
                  aplicarFiltros();
                }
              "
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="4" md="3">
          <v-select
            v-model="filters.tipoSolicitud"
            :items="tiposSolicitud"
            label="Tipo de solicitud"
            prepend-icon="mdi-filter-variant"
            dense
            @input="aplicarFiltros()"
            outlined
            clearable
            item-text="label"
            item-value="value"
          ></v-select>
        </v-col>

        <v-col cols="12" sm="4" md="3">
          <v-select
            v-model="filters.agencia"
            :items="agencias"
            label="Agencia"
            dense
            @input="aplicarFiltros()"
            outlined
            clearable
            item-text="text"
            item-value="value"
          ></v-select>
        </v-col>
      </v-row>
    </v-card>

    <!-- Gráficas -->
    <v-row dense>
      <v-col cols="12" md="6">
        <v-card color="grey lighten-3" class="pa-2">
          <v-card-text class="pa-0 pt-1 pb-1">
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <PieChart
                    height="470px"
                    tipo="Cantidad de solicitudes por agencia"
                    title="Cantidad de solicitudes por agencia"
                    :colors="[]"
                    :data="cantidadSolicitudes"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card color="grey lighten-3" class="pa-2">
          <v-card-text class="pa-0 pt-1 pb-1">
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <BarChart
                    height="470px"
                    tipo="Cantidad de solicitudes por compania"
                    title="Cantidad de solicitudes por compania"
                    :colors="[]"
                    :data="cantidadSolicitudesCompania"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="12">
        <v-card color="grey lighten-3" class="pa-2">
          <v-card-text class="pa-0 pt-1 pb-1">
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <LineChart
                    :data="cantidadSolicitudesEnElTiempo"
                    tipo="Solicitudes"
                    color="#10b981"
                    height="300px"
                    title="Solicitudes por día"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Nueva gráfica de proformas por embarcación -->
    <v-row dense>
      <v-col cols="12" md="6">
        <v-card color="grey lighten-3" class="pa-2">
          <v-card-text class="pa-0 pt-1 pb-1">
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <PieChart
                    :data="proformasEmbarcaciones"
                    tipo="Proformas por Embarcación"
                    title=""
                    :colors="[
                      '#FF6384',
                      '#36A2EB',
                      '#FFCE56',
                      '#4BC0C0',
                      '#9966FF',
                      '#FF9F40',
                    ]"
                    height="400px"
                    :legendShow="true"
                    :formatAsCurrency="true"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-title class="text-center pt-0">
            <h3 class="subtitle-1 mx-auto">Total de Proformas por Embarcación</h3>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card color="grey lighten-3" class="pa-2">
          <v-card-text class="pa-0 pt-1 pb-1">
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <PieChart
                    :data="proformasAgencias"
                    tipo="Proformas por Agencia"
                    title=""
                    :colors="[
                      '#FF6384',
                      '#36A2EB',
                      '#FFCE56',
                      '#4BC0C0',
                      '#9966FF',
                      '#FF9F40',
                    ]"
                    height="400px"
                    :legendShow="true"
                    :formatAsCurrency="true"
                  />
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-title class="text-center pt-0">
            <h3 class="subtitle-1 mx-auto">Total de Proformas por Agencia</h3>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  cantidadSolicitudesAgenicia,
  selectAgencias,
  cantidadSolicitudesEnElTiempo,
  cantidadSolicitudesCompania,
  proformasEmbarcaciones,
  proformasAgencias,
} from "../api/endpoints";

import PieChart from "./components/graficas/PieChart.vue";
import BarChart from "./components/graficas/BarChart.vue";
import LineChart from "./components/graficas/LineChart.vue";
export default {
  components: {
    PieChart,
    BarChart,
    LineChart,
  },
  data() {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");

    const startOfMonth = `${yyyy}-${mm}-01`;
    const endOfMonth = `${yyyy}-${mm}-${new Date(yyyy, today.getMonth() + 1, 0)
      .getDate()
      .toString()
      .padStart(2, "0")}`;

    return {
      startDateMenu: false,
      endDateMenu: false,
      agencias: [],
      filters: {
        startDate: startOfMonth,
        endDate: endOfMonth,
        tipoSolicitud: "solicitudUnica",
        agencia: "67102a46cb25f6d8e2ec42f2",
      },
      tiposSolicitud: [
        { label: "Solicitud Unica", value: "solicitudUnica" },
        { label: "Cambio de Guardia", value: "cambioGuardia" },
        { label: "Vehiculo Personal", value: "vehiculoPersonal" },
      ],
      cantidadSolicitudes: [],
      cantidadSolicitudesCompania: [],
      cantidadSolicitudesEnElTiempo: [],
      proformasEmbarcaciones: [],
      proformasAgencias: [],
    };
  },
  created() {
    this.listarAgencias();
    this.obtenerCantidadSolicitudes();
    this.obtenerTendenciaEnElTiempo();
    this.obtenerCantidadSolicitudesCompania();
    this.obtenerProformasTotalesEmbarcaciones();
    this.obtenerProformasTotalesAgencias();
  },
  methods: {
    aplicarFiltros() {
      this.obtenerCantidadSolicitudes();
      this.obtenerTendenciaEnElTiempo();
      this.obtenerCantidadSolicitudesCompania();
      this.obtenerProformasTotalesEmbarcaciones();
      this.obtenerProformasTotalesAgencias();
    },

    formatCurrency(value) {
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
      }).format(value);
    },
    async obtenerCantidadSolicitudes() {
      try {
        const response = await cantidadSolicitudesAgenicia(this.filters);
        this.cantidadSolicitudes = response;
      } catch (error) {
        console.error("Error al obtener la cantidad de solicitudes:", error);
      }
    },
    async obtenerProformasTotalesEmbarcaciones() {
      try {
        const response = await proformasEmbarcaciones(this.filters);
        this.proformasEmbarcaciones = response.map((item) => ({
          name: item.name[0],
          value: item.value,
          _id: item._id[0],
        }));
      } catch (error) {
        console.error("Error al obtener las proformas por embarcación:", error);
      }
    },
    async obtenerProformasTotalesAgencias() {
      try {
        const response = await proformasAgencias(this.filters);
        this.proformasAgencias = response.map((item) => ({
          name: item.name[0],
          value: item.value,
          _id: item._id[0],
        }));
      } catch (error) {
        console.error("Error al obtener las proformas por agencia:", error);
      }
    },
    async obtenerTendenciaEnElTiempo() {
      try {
        const response = await cantidadSolicitudesEnElTiempo(this.filters);
        this.cantidadSolicitudesEnElTiempo = response;
      } catch (error) {
        console.error("Error al obtener la tendencia en el tiempo:", error);
      }
    },
    async listarAgencias() {
      try {
        const response = await selectAgencias();
        this.agencias = response;
      } catch (error) {
        console.error("Error al obtener la lista de agencias:", error);
      }
    },
    async obtenerCantidadSolicitudesCompania() {
      try {
        const response = await cantidadSolicitudesCompania(this.filters);
        this.cantidadSolicitudesCompania = response;
      } catch (error) {
        console.error("Error al obtener la cantidad de solicitudes:", error);
      }
    },
  },
};
</script>
